import styled from 'styled-components'

/**
 * Click handling lives on the outer CardNavWrapper (an <a>) — this is just
 * the text-stacking column. `display: flex; flex-direction: column;`
 * restores the implicit stacking the original `styled(TouchableOpacity)`
 * provided; without it, RN-Web Text children render inline and collapse
 * onto one line (OB-503).
 */
export const ListLMCTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 4;
    margin-left: 24px;
    max-width: 200px;
`
